import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";

const CookieSection = styled.div`
  background: rgba(0, 0, 0, 0.2);
  z-index: 2147483646;
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  // Add animation 400ms ease in/out
`;

const ActionSection = styled.div`
  position: fixed;
  z-index: 2147483645;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: #fff;
  max-height: 90%;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 1rem;
  display: flex;
  @media screen and (max-width: 991px) {
    display: block;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex: 3;
`;
const ButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-evenly;
  align-items: center;
`;

const StyledButton = styled.button`
  height: 46px;
  padding: 0 24px;
  border-radius: 23px;
  border: solid 2px #1e5bb5;
  background-color: #1e5bb5;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  opacity: ${({ disabled }) => (disabled ? "0.3" : "1")};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  &:focus {
    outline: none;
  }
`;

const SecondaryButton = styled.button`
  height: 46px;
  padding: 0 24px;
  border-radius: 23px;
  border: solid 2px #1e5bb5;
  background-color: #fff;
  color: #1e5bb5;
  font-size: 16px;
  font-weight: 600;
  opacity: ${({ disabled }) => (disabled ? "0.3" : "1")};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  &:focus {
    outline: none;
  }
`;

const CookieConsent = ({ handleCookieConsent }) => {
  return (
    <CookieSection>
      <ActionSection>
        <TextWrapper>
          <div>
            <h5>Cookie Notice</h5>
            <p>
              This website uses cookies to provide you with the best possible
              experience. These will be set only if you accept. For more details
              about cookies and how they are used, refer to
              <Link to="/legal"> TrustFlight Privacy Policy</Link>.
            </p>
          </div>
        </TextWrapper>
        <ButtonWrapper>
          <SecondaryButton onClick={() => handleCookieConsent(false)}>
            Reject Cookies
          </SecondaryButton>
          <StyledButton onClick={() => handleCookieConsent(true)}>
            Accept Cookies
          </StyledButton>
        </ButtonWrapper>
      </ActionSection>
    </CookieSection>
  );
};

export default CookieConsent;
